import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const [mode, setMode] = useState(() => {
        return localStorage.getItem("fixdesk-theme") || "dark";
    });

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", mode);
        localStorage.setItem("fixdesk-theme", mode);
    }, [mode]);

    const toggleTheme = () => {
        setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    return (
        <ThemeContext.Provider value={{ mode, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
